import React from 'react'
import { Dialog } from 'primereact/dialog'
import ProductService from '../../app/service/productService'
import DialogFooter from '../dialogFooter'
import ConstantsUtil from '../../context/constantsUtil'
import * as popUp from '../toastr'
import GeneralServices from '../../app/service/generalServices'
import DadosNfseComponent from './dadosNfseComponent'
import CustomCalendar from '../calendar/customCalendar'
import InputChooseFornecedor from '../contasAPagar/inputChooseFornecedor'
import InputChooseGrupoDePagamento from '../contasAPagar/inputChooseGrupoDePagamento'
import NfseService from '../../app/service/nfse/NfseService'
import HandleErrorService from '../../app/service/handleErrorService'
import AuthService from '../../app/service/authService'
import SelectMenu from '../selectMenu'
import { InputTextarea } from 'primereact/inputtextarea'

class CheckNfseDialog extends React.Component {

    constructor(){
        super();
        this.productService = new ProductService();
        this.nfseService = new NfseService()
        this.generalServices = new GeneralServices()
        this.quantidadeParcelasComponentRef = React.createRef()
        this.dadosNFComponentRef = React.createRef()
        this.inputTextObservacaoRef = React.createRef()
        
    }

    state = {

        dhEmi: '',
        dhEmiView: '',
        inputDhEmiErrorClass: '',
        errorDhEmiMessage: '',

        dataCompetencia: '',
        dataCompetenciaView: '',
        inputDataCompetenciaErrorClass: '',
        errorDataCompetenciaMessage: '',

        hour: '',
        inputHourErrorClass: '',
        errorHourMessage: '',

        qtdParcelas: '',
        inputParcelasErrorClass: '',
        errorParcelasMessage: 'Informe a quantidade de Parcelas',

        pagamentoList: [],

        transactions: [],

        didUpdated: false,

        grupoDePagamentoLabel: '',

        tipoContaGerencial: ConstantsUtil.contaGerencialGeral,
        grupoDePagamentoEspecifico: null,
        inputGrupoDePagamentoEspecificoErrorClass: '',
        inputFornecedorErrorClass: '',

        numero: null,
        inputNumeroErrorClass: '',

        codigoVerificacao: '',
        inputCodigoVerificacaoErrorClass: '',

        inputDescricaoServicoErrorClass: '',

    }    

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){
            
            // console.log("this.props.NFToValidate.dataCompetencia: ", this.props.NFToValidate.dataCompetencia)
            // console.log("this.props.NFToValidate: ", this.props.NFToValidate)
            
            this.setState({
                numero: null,
                codigoVerificacao: '',
            })

            if(!GeneralServices.isEmptyObject(this.props.NFToValidate)){
                this.setState({
                    dhEmi: this.props.NFToValidate.dhEmi,
                    dhEmiView: GeneralServices.convertBrStringToJsDate(this.props.NFToValidate.dhEmi),
                    dataCompetencia: this.props.NFToValidate.dataCompetencia,
                    dataCompetenciaView: GeneralServices.convertBrStringToJsDate(this.props.NFToValidate.dataCompetencia),
                    grupoDePagamentoLabel: this.props.NFToValidate.grupoDePagamento ? this.props.NFToValidate.grupoDePagamento.nome : '',
                    numero: this.props.NFToValidate.numero,
                    codigoVerificacao: this.props.NFToValidate.codigoVerificacao,
                })

                this.setDescricaoServico()

                if(this.props.NFToValidate.prestadorServico){
                    if(this.props.handleSelectionFornecedorChange){
                        this.props.handleSelectionFornecedorChange(this.props.NFToValidate.prestadorServico)
                    }
                }

            }


            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }

        }
    }

    setDescricaoServico = async () => {
        if(this.props.NFToValidate.servico){
            await this.generalServices.sleep(100)
            this.inputTextObservacaoRef.current.value = this.props.NFToValidate.servico
        }
    }


    hideDialog = () => {
        this.dadosNFComponentRef.current.resetView()
        // this.dadosNFComponentRef.current.resetData()
        this.props.hideDialog()
        this.setState({didUpdated: false})
    }

    resetView = () => {
        this.setState({
            inputDhEmiErrorClass: '',
            errorDhEmiMessage: '',

            inputDataCompetenciaErrorClass: '',
            errorDataCompetenciaMessage: '',

            inputFornecedorErrorClass: '',

            inputNumeroErrorClass: '',

            inputCodigoVerificacaoErrorClass: '',

            inputDescricaoServicoErrorClass: '',

        })
    }
    
    checkData = () => {

        this.setState({inputGrupoDePagamentoEspecificoErrorClass: ''})

        let check = true

        if(!this.state.dhEmi){
            this.setState({
                inputDhEmiErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorDhEmiMessage: "Informe a Data de Emissão"
            })
            check = false
        }

        if(!this.state.dataCompetencia){
            this.setState({
                inputDataCompetenciaErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorDataCompetenciaMessage: "Informe a Data de Comeptência"
            })
            check = false
        }
        
        if(this.props.isCreateNFSe && !this.props.NFToValidate.prestadorServico){
            this.setState({inputFornecedorErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(
            this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento
            && !this.state.grupoDePagamentoEspecifico
        ){
            this.setState({inputGrupoDePagamentoEspecificoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(this.props.isCreateNFSe && !this.state.numero){
            this.setState({inputNumeroErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(this.props.isCreateNFSe && !this.state.codigoVerificacao){
            this.setState({inputCodigoVerificacaoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(this.props.isCreateNFSe && !this.inputTextObservacaoRef.current.value){
            this.setState({inputDescricaoServicoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        let checkDadosNfComponent = this.dadosNFComponentRef.current.checkData()
        let checkDataValidacao = this.checkTimestamp(`${this.dadosNFComponentRef.current.state.dataEntrada} - ${this.dadosNFComponentRef.current.state.hour}`)
        return checkDadosNfComponent && checkDataValidacao && check
    }

    checkTimestamp(receivedTimestamp) {

        // Função auxiliar para converter a string de timestamp em um objeto Date
        function parseTimestamp(timestamp) {
            const [datePart, timePart] = timestamp.split(" - ");
            const [day, month, year] = datePart.split("-");
            const [hours, minutes] = timePart.split(":");
    
            // Cria um novo objeto Date usando os componentes extraídos
            return new Date(year, month - 1, day, hours, minutes);
        }
    
        // Obtenha a data e hora atuais
        const currentTimestamp = new Date();
    
        // Converte o timestamp recebido em um objeto Date
        const receivedTime = parseTimestamp(receivedTimestamp).getTime();
        const currentTime = currentTimestamp.getTime();
    
        // Calcule a diferença em milissegundos
        const differenceInMillis = receivedTime - currentTime;
    
        // Verifique se a diferença é maior que 10 minutos (600000 milissegundos)
        if (differenceInMillis > 600000) {
            popUp.warningPopUp("Data/Hora de Entrada está no futuro.")
            return false
        }
        return true
    }    

    callSave = () => {
        this.resetView()
        // console.log("this.dadosNFComponentRef.current", this.dadosNFComponentRef.current)
        // console.log("this.dadosNFComponentRef.current.state", this.dadosNFComponentRef.current.state)
        if(this.checkData()){
            
            /*
            Altera obj NFToValidate recebido.
            Assim, quando o componente pai (transactionByNFTable) for salvar, o objeto já estará modificado por referência.
            */
            // console.log("pagamentoList final", this.dadosNFComponentRef.current.getPagamentoList())
            // console.log("valorAcrescimoDesconto", this.dadosNFComponentRef.current.getRealValorAcrescimoDesconto())
            this.props.NFToValidate.pagamentoList = this.dadosNFComponentRef.current.getPagamentoList()
            this.props.NFToValidate.valorAcrescimoDesconto = this.dadosNFComponentRef.current.getRealValorAcrescimoDesconto()
            this.props.NFToValidate.formaDePagamento = this.dadosNFComponentRef.current.getFormaDePagamento()
            this.props.NFToValidate.gravarEscolhaFormaDePagamento = this.dadosNFComponentRef.current.getGravarEscolhaFormaDePagamento()
            this.props.NFToValidate.dataCompetencia = this.state.dataCompetencia
            
            if(this.props.isCreateNFSe){
                this.props.NFToValidate.dhEmi = this.state.dhEmi
                this.props.NFToValidate.numero = this.state.numero
                this.props.NFToValidate.codigoVerificacao = this.state.codigoVerificacao
                this.props.NFToValidate.servico = this.inputTextObservacaoRef.current.value
            }
            
            if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
                this.props.NFToValidate.grupoDePagamentoEspecifico = this.state.grupoDePagamentoEspecifico
            }

            // console.log("this.props.NFToValidate: ", this.props.NFToValidate)
            this.hideDialog()
            this.props.save()
        }
    }

    handleDataChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        const nameView = name+"View"
        await this.setState({[nameView]: value })
    }

    handleSelectionGrupoDePagamentoChange = grupoDePagamento => {

        if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
            this.setState({grupoDePagamentoEspecifico: grupoDePagamento})
            return
        }

        AuthService.startBlockUi()
        this.nfseService.atualizaGrupoDePagamento(this.props.NFToValidate, grupoDePagamento)
        .then(response => {
            popUp.successPopUp("Conta Gerencial atualizada com sucesso!")
            this.setState({grupoDePagamentoLabel: grupoDePagamento.nome}) //para atualizar na tela sem precisar buscar do backend novamente.
            if(this.props.atualizaGrupoDePagamento){
                this.props.atualizaGrupoDePagamento(grupoDePagamento)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
    }

    getGrupoDePagamentoLabel = () => {
        if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
            return this.state.grupoDePagamentoEspecifico ? this.state.grupoDePagamentoEspecifico.nome : ''
        }
        return this.state.grupoDePagamentoLabel
    }

    setGrupoDePagamentoLabel = (grupoDePagamentoLabel) => {
        this.setState({grupoDePagamentoLabel})
    }

    getHeader = () => {
        if(this.props.isCreateNFSe){
            return "Cadastrar NFSe"
        }

        return `Validar NFSe (N° ${this.props.NFToValidate ? this.props.NFToValidate.numero : ''})`

    }

    render() {

        const dialogFooter = (
            <DialogFooter
                save = {this.callSave}
                hideDialog = {this.hideDialog}
                disabled={this.props.disabled || GeneralServices.isTelaPreValidacaoNFs()}
            />
        )

        const renderNumeroCodigoDeVerificacaoEDescricaoServico = () => {
            if(this.props.isCreateNFSe){
                return (
                    <>
                    <br />
                    <div className='row'>


                        <div className="col-md-2">
                            <label htmlFor="date">N° do Documento</label>
                            <input
                                type="number"
                                className={"form-control " + this.state.inputNumeroErrorClass}
                                style={{ width: '12rem' }}
                                value = {this.state.numero}
                                name="numero"
                                onChange={this.handleChange}
                            />
                            <div className="invalid-feedback">Informe o número</div>
                        </div>

                        <div className="col-md-2">
                            <label htmlFor="date">Código de Verificação</label>
                            <input
                                type="text"
                                className={"form-control " + this.state.inputCodigoVerificacaoErrorClass}
                                style={{ width: '12rem' }}
                                value = {this.state.codigoVerificacao}
                                name="codigoVerificacao"
                                onChange={this.handleChange}
                            />
                            <div className="invalid-feedback">Infome do Código de Verificação</div>
                        </div>

                        <div className="col-md-4">
                            <InputTextarea
                                className={"form-control " + this.state.inputDescricaoServicoErrorClass}
                                ref={this.inputTextObservacaoRef}
                                rows={3}
                                autoResize
                                placeholder={"Descrição do Serviço"}
                            />
                            <div className="invalid-feedback">Infome a Descrição do Serviço</div>
                        </div>


                    </div>
                    </>
                )
            }
        }

        return (
            <>
            <Dialog
                visible={this.props.visible}
                style={{ width: '95vw' }}
                header={this.getHeader()}
                modal
                className="p-fluid"
                footer={dialogFooter}
                onHide={this.hideDialog}
            >
                
                <div className='row'>

                    <div className='col-md-2'>
                        <CustomCalendar
                            label={`Data de Emissão`}
                            // ref={this.dateInputRef}
                            id="dhEmi"
                            name="dhEmi"
                            value={this.state.dhEmiView}
                            noHTMLFormat
                            onChange={this.handleDataChange}
                            inputDateErrorClass={this.state.inputDhEmiErrorClass}
                            errorDateMessage={this.state.errorDhEmiMessage}
                            disabled={!this.props.isCreateNFSe}
                        />
                    </div>

                    <div className='col-md-2'>
                        <CustomCalendar
                            label={`Data de Competência`}
                            ref={this.dateInputRef}
                            id="dataCompetencia"
                            name="dataCompetencia"
                            value={this.state.dataCompetenciaView}
                            noHTMLFormat
                            onChange={this.handleDataChange}
                            inputDateErrorClass={this.state.inputDataCompetenciaErrorClass}
                            errorDateMessage={this.state.errorDataCompetenciaMessage}
                        />
                    </div>

                    <div className='col-md-3'>
                        <InputChooseFornecedor
                            noHTMLFormat
                            selectedFornecedorLabel={this.props.NFToValidate && this.props.NFToValidate.prestadorServico ? this.props.NFToValidate.prestadorServico.nome : ''}
                            disabled={!this.props.isCreateNFSe}
                            handleSelectionFornecedorChange={this.props.handleSelectionFornecedorChange}
                            inputFornecedorErrorClass={this.state.inputFornecedorErrorClass}
                        />
                    </div>

                    <div className="col-md-2">
                        <label>Tipo de Conta Gerencial</label>
                        <SelectMenu
                            className={"form-control " }
                            name="tipoContaGerencial"
                            list={ConstantsUtil.tipoContaGerencialSelectList}
                            value={this.state.tipoContaGerencial}
                            onChange={(event) => {
                                this.setState({grupoDePagamentoEspecifico: null})
                                this.handleChange(event)
                            }}
                            // disabled
                        />
                        <div className="invalid-feedback">Informe o Tipo</div>
                    </div>

                    <div className='col-md-3'>
                        <InputChooseGrupoDePagamento
                            header="Conta Gerencial (DRE)"
                            noHTMLFormat
                            selectedGrupoDePagamentoLabel={this.getGrupoDePagamentoLabel()}
                            handleSelectionGrupoDePagamentoChange={this.handleSelectionGrupoDePagamentoChange}
                            inputGrupoDePagamentoErrorClass={this.state.inputGrupoDePagamentoEspecificoErrorClass}
                        />              
                    </div>

                </div>

                {renderNumeroCodigoDeVerificacaoEDescricaoServico()}

                <DadosNfseComponent
                    ref={this.dadosNFComponentRef}
                    insideValidateNFDialog
                    NFToValidate={this.props.NFToValidate}
                    callSave={this.callSave}
                    isCreateNFSe={this.props.isCreateNFSe}
                    handleImpostoRetidoChange={this.props.handleImpostoRetidoChange}
                    forceUpdate={this.props.forceUpdateQuantidadeParcelasComponent}
                    doneForcedUpdate={this.props.doneForcedUpdateQuantidadeParcelasComponent}
                />

            </Dialog>
            

            </>

        )
    }
}

export default CheckNfseDialog